var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSolIotMonitoring01 = function SvgSolIotMonitoring01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sol_iot_monitoring-01_svg2__a",
    x1: 29.39,
    x2: 163.23,
    y1: 175.46,
    y2: 2.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3D43C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#5934b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#7523a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#89179f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#9b0d98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_iot_monitoring-01_svg2__a",
    id: "sol_iot_monitoring-01_svg2__b",
    x1: 62.44,
    x2: 196.27,
    y1: 201.06,
    y2: 28.26
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_iot_monitoring-01_svg2__a",
    id: "sol_iot_monitoring-01_svg2__c",
    x1: 28.59,
    x2: 162.42,
    y1: 174.84,
    y2: 2.04
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_iot_monitoring-01_svg2__a",
    id: "sol_iot_monitoring-01_svg2__d",
    x1: 80.39,
    x2: 214.22,
    y1: 214.96,
    y2: 42.16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_iot_monitoring-01_svg2__a",
    id: "sol_iot_monitoring-01_svg2__e",
    x1: 19.79,
    x2: 153.63,
    y1: 168.03,
    y2: -4.77
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_iot_monitoring-01_svg2__a",
    id: "sol_iot_monitoring-01_svg2__f",
    x1: 8.31,
    x2: 142.14,
    y1: 159.13,
    y2: -13.67
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M185.36 71.36c-.9-21.43-18.48-38.38-39.94-38.49-2.33 0-4.66.22-6.95.64C128.8 7.05 99.51-6.56 73.05 3.11a50.99 50.99 0 0 0-32.24 36.65h-1.66C17.44 39.88-.07 57.57.04 79.28c0 22.88 14.45 39.5 34.36 39.5h24.99c1.73 0 3.12-1.4 3.12-3.12s-1.4-3.12-3.12-3.12H34.4c-16.56 0-28.11-13.68-28.11-33.25-.07-18.21 14.59-33.04 32.8-33.19 1.27 0 2.55.09 3.81.23 1.65.23 3.19-.88 3.5-2.51C50.46 19.41 73.53 2.93 97.92 6.99a44.79 44.79 0 0 1 35.5 31.19 3.13 3.13 0 0 0 3.75 2.11c2.69-.73 5.46-1.13 8.25-1.17 18.68.09 33.76 15.28 33.72 33.96v.37c-.02 1.34.81 2.55 2.08 3 7.48 2.56 12.51 9.6 12.5 17.51 0 9.01-6.03 18.57-17.18 18.57h-35.92c-1.73 0-3.12 1.4-3.12 3.12s1.4 3.12 3.12 3.12h35.92c14.67 0 23.43-12.62 23.43-24.82 0-9.75-5.71-18.6-14.6-22.6Z",
    style: {
      fillRule: "evenodd",
      fill: "url(#sol_iot_monitoring-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.12 169.07v-41.33c6.68-1.73 10.7-8.54 8.97-15.22s-8.54-10.7-15.22-8.97-10.7 8.54-8.97 15.22c1.14 4.4 4.57 7.84 8.97 8.97v41.33c-8.45 1.73-13.9 9.98-12.18 18.43 1.73 8.45 9.98 13.9 18.43 12.18 8.45-1.73 13.9-9.98 12.18-18.43a15.63 15.63 0 0 0-12.18-12.18m-9.37-53.41c0-3.45 2.8-6.25 6.25-6.25s6.25 2.8 6.25 6.25-2.8 6.25-6.25 6.25-6.25-2.8-6.25-6.25m6.25 78.09c-5.18 0-9.37-4.2-9.37-9.37s4.2-9.37 9.37-9.37 9.37 4.2 9.37 9.37-4.2 9.37-9.37 9.37",
    style: {
      fillRule: "evenodd",
      fill: "url(#sol_iot_monitoring-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9 75.04c-6.9 0-12.5 5.59-12.5 12.49 0 5.7 3.85 10.68 9.37 12.11v62.88H49.71c-1.73-8.45-9.98-13.9-18.43-12.18-8.45 1.73-13.9 9.98-12.18 18.43 1.73 8.45 9.98 13.9 18.43 12.18a15.63 15.63 0 0 0 12.18-12.18h22.18c1.73 0 3.12-1.4 3.12-3.12V99.64c5.51-1.42 9.37-6.39 9.37-12.09 0-6.9-5.58-12.5-12.49-12.5Zm-37.5 99.97c-5.18 0-9.37-4.2-9.37-9.37s4.2-9.37 9.37-9.37 9.37 4.2 9.37 9.37-4.2 9.37-9.37 9.37m37.49-81.22c-3.45 0-6.25-2.8-6.25-6.25s2.8-6.25 6.25-6.25 6.25 2.8 6.25 6.25-2.8 6.25-6.25 6.25",
    style: {
      fill: "url(#sol_iot_monitoring-01_svg2__c)",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.6 150.02c-7.42 0-13.82 5.22-15.31 12.5h-19.06V99.64c6.68-1.73 10.7-8.54 8.97-15.22s-8.54-10.7-15.22-8.97-10.7 8.54-8.97 15.22c1.14 4.4 4.57 7.84 8.97 8.97v66.01c0 1.73 1.4 3.12 3.12 3.12h22.18c1.73 8.45 9.98 13.9 18.43 12.18 8.45-1.73 13.9-9.98 12.18-18.43-1.48-7.27-7.88-12.49-15.3-12.5Zm-43.73-62.48c0-3.45 2.8-6.25 6.25-6.25s6.25 2.8 6.25 6.25-2.8 6.25-6.25 6.25-6.25-2.8-6.25-6.25m43.73 87.47c-5.18 0-9.37-4.2-9.37-9.37s4.2-9.37 9.37-9.37 9.37 4.2 9.37 9.37-4.2 9.37-9.37 9.37",
    style: {
      fillRule: "evenodd",
      fill: "url(#sol_iot_monitoring-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.41,
    cy: 65.23,
    r: 4.31,
    style: {
      fill: "url(#sol_iot_monitoring-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.72 47.98V35.04a4.31 4.31 0 0 0-8.62 0v12.94a4.31 4.31 0 0 0 8.62 0",
    style: {
      fillRule: "evenodd",
      fill: "url(#sol_iot_monitoring-01_svg2__f)"
    }
  }));
};
export default SvgSolIotMonitoring01;